<section
  *ngIf="i18nMessage"
  class="alert alert-info qa-lti-alert__message"
  role="alert"
>
  {{ i18nMessage }}
</section>
